const NS = 'KeyDetailsBlock';
const CLS = 'keyDetailsBlock';

export class KeyDetailsBlock {
	constructor(el) {
		this.el = el;
		this.$el = $(el);
		this.$timelist = $(el).find('.timelist div');
		this.$btnMore = $(el).find('.btn-more');
		this.init();
	}

	init() {
		console.log('init');
		if(this.$timelist.length > 3) {
			this.$btnMore.removeClass('d-none');
			this.$btnMore.on('click', () => {
				this.$el.find('.timelist .d-none').removeClass('d-none');
				this.$btnMore.addClass('d-none');
			});
		}
	}
}
